import { render } from "./submit10.vue?vue&type=template&id=4994afd7&scoped=true"
const script = {}

import "./submit10.vue?vue&type=style&index=0&id=4994afd7&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4994afd7"]])

export default __exports__